import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    record(id) {
        return this.transformer.one(
            this.try(
                this.baseQuery()
                    .include('person-news')
                    .find(id)
            )
        );
    }

    search(keywords) {
        return this.transformer.many(
            this.try(
                this.baseSearchQuery(
                    ['news-modules.modules.modules'],
                    ['title', 'summary', 'news-modules.modules.modules.attributes']
                    , keywords
                ).get()
            )
        ).then(collection => {
            return collection.map(record => {
                return {
                    type: 'news',
                    id: record.id,
                    text: record.title,
                    resource: record,
                    badgeVariant: 'alpha',
                    badgeText: 'News',
                }
            })
        })
    }
}

export default Repository;
